import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APPCONFIG } from 'app/main/config';
import { WarehouseFileMetadata, WarehouseFileUploadRequest, WarehouseIdentifyResponse } from './models';

export interface WarehouseFileContent {
    blob: Blob;
    contentType: string;
}

@Injectable()
export class WarehouseDeliveryDocumentApiService {

    private readonly baseUrl = APPCONFIG.appUrl + '/deliveryDocument/warehouse';

    constructor(private http: HttpClient) {
    }

    identify(shipmentNo: string, plantCode: string, jobPkId?: string): Observable<WarehouseIdentifyResponse> {
        const body = { shipmentNo, plantCode, jobPkId: jobPkId || '' };
        return this.http.post<any>(this.baseUrl + '/identify', body)
            .pipe(map(res => res.data as WarehouseIdentifyResponse));
    }

    listFileMetadata(accessToken: string, documentId: number): Observable<WarehouseFileMetadata[]> {
        return this.http.get<any>(this.baseUrl + '/' + documentId + '/files', { headers: this.authHeaders(accessToken) })
            .pipe(map(res => res.data as WarehouseFileMetadata[]));
    }

    getFileContent(accessToken: string, documentId: number, fileId: number): Observable<WarehouseFileContent> {
        return this.getContent(accessToken, this.baseUrl + '/' + documentId + '/files/' + fileId + '/content');
    }

    getLegacyContent(accessToken: string, documentId: number): Observable<WarehouseFileContent> {
        return this.getContent(accessToken, this.baseUrl + '/' + documentId + '/legacy/content');
    }

    appendFiles(accessToken: string, documentId: number, files: WarehouseFileUploadRequest[]): Observable<WarehouseFileMetadata[]> {
        return this.http.post<any>(this.baseUrl + '/' + documentId + '/files', files, { headers: this.authHeaders(accessToken) })
            .pipe(map(res => res.data as WarehouseFileMetadata[]));
    }

    deleteFile(accessToken: string, documentId: number, fileId: number): Observable<WarehouseFileMetadata[]> {
        return this.http.delete<any>(this.baseUrl + '/' + documentId + '/files/' + fileId, { headers: this.authHeaders(accessToken) })
            .pipe(map(res => res.data as WarehouseFileMetadata[]));
    }

    private getContent(accessToken: string, url: string): Observable<WarehouseFileContent> {
        return this.http.get(url, { headers: this.authHeaders(accessToken), observe: 'response', responseType: 'blob' })
            .pipe(map(res => ({
                blob: res.body,
                contentType: res.headers.get('Content-Type') || 'application/octet-stream'
            })));
    }

    private authHeaders(accessToken: string): HttpHeaders {
        return new HttpHeaders({ 'Content-Type': 'application/json', 'idToken': accessToken });
    }
}
